import React, { Component } from 'react'
import { withFormik, Form, Field } from 'formik'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Input, Select, Button, FlexContainer, FlexRow, FlexedItem, Col, Footer } from 'components'
import sharedMessages from 'containers/sharedMessages'
import {isEmpty} from "utils";
import { isAutoCompleteEnabled } from 'utils/requests'
import AddressList from './AddressList'
import messages from './messages'

const P = styled.p`
  margin-bottom: 15px !important;
`
const AddressDropdown = styled.p`
  position: relative;
`
const ExtendedCol = Col.extend`
  padding-top: 15px;
`

export class AddressForm extends Component {
  static propTypes = {
    values: PropTypes.object,
    errors: PropTypes.object,
    touched: PropTypes.object,
    setTouched: PropTypes.func,
    setValues: PropTypes.func,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    handleSubmit: PropTypes.func,
    validationSchema: PropTypes.func,
    addressComplete: PropTypes.func,
    retrieveAddress: PropTypes.func,
    address: PropTypes.object,
    isValid: PropTypes.bool,
    handleSubmitting: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    isAddressValidated: PropTypes.bool,
    matchedAddresses: PropTypes.array,
  }
  componentDidMount() {
    const schema = this.props.validationSchema()
    const { isAddressValidated, setTouched } = this.props
    schema
      .validate(this.props.values)
      .then(data => {})
      .catch(err => {
        console.log(err)
      })
    if (isAddressValidated) {
      setTouched({ [messages.addressLine1.sid]: true })
    }
  }
  shouldComponentUpdate(nextProps) {
    const { setValues, address, values } = this.props
    if (nextProps.address !== address) {
      setValues({ ...values, ...nextProps.address })
    }
    return true
  }
  handleAddressChange = event => {
    const { handleChange, addressComplete } = this.props
    if (isAutoCompleteEnabled()) {
      addressComplete(event.target.value)
    }
    handleChange(event)
  }
  handleDropdownClose = event => {
    const { addressComplete, handleBlur } = this.props
    if (isAutoCompleteEnabled()) {
      addressComplete('')
    }
    handleBlur(event)
  }
  render() {
    const {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmitting,
      handleSubmit,
      isValid,
      isSubmitting,
      isAddressValidated,
      matchedAddresses,
      retrieveAddress,
    } = this.props
    const isAddressCompleteEnabled = isAutoCompleteEnabled();
    return (
        <Form className="height-percent-100 flex-direction-column">
            <FlexContainer>
                <FlexedItem className="styled-scrollbars">
                    <ExtendedCol>
                        <h3>
                            <FormattedMessage {...messages.subheader} />
                        </h3>
                        <P>
                            <FormattedMessage {...messages.legal} />
                        </P>
                        <Input
                            label={<FormattedMessage {...sharedMessages.firstName} />}
                            type="text"
                            name={sharedMessages.firstName.sid}
                            autoComplete="billing given-name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values[sharedMessages.firstName.sid]}
                            touched={touched[sharedMessages.firstName.sid]}
                            errors={errors[sharedMessages.firstName.sid]}
                        />
                        <Input
                            label={<FormattedMessage {...sharedMessages.lastName} />}
                            type="text"
                            autoComplete="billing family-name"
                            name={sharedMessages.lastName.sid}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values[sharedMessages.lastName.sid]}
                            touched={touched[sharedMessages.lastName.sid]}
                            errors={errors[sharedMessages.lastName.sid]}
                        />
                        <Input
                            label={<FormattedMessage {...sharedMessages.email} />}
                            type={sharedMessages.email.sid}
                            autoComplete="billing email"
                            name={sharedMessages.email.sid}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values[sharedMessages.email.sid]}
                            touched={touched[sharedMessages.email.sid]}
                            errors={errors[sharedMessages.email.sid]}
                        />
                        <AddressDropdown>
                            <Input
                                label={<FormattedMessage {...messages.addressLine1} />}
                                type="text"
                                className="dropdown-radius"
                                autoComplete={isAddressCompleteEnabled ? "none" : "billing address-line1"}
                                name={messages.addressLine1.sid}
                                onChange={(e) => this.handleAddressChange(e)}
                                onBlur={(e) => this.handleDropdownClose(e)}
                                value={values[messages.addressLine1.sid]}
                                touched={touched[messages.addressLine1.sid]}
                                errors={errors[messages.addressLine1.sid]}
                            />
                            {matchedAddresses.length ? (
                                <AddressList matchedAddresses={matchedAddresses} retrieveAddress={retrieveAddress} />
                            ) : null}
                        </AddressDropdown>
                        <Input
                            label={<FormattedMessage {...messages.addressLine2} />}
                            type="text"
                            name={messages.addressLine2.sid}
                            autoComplete={isAddressCompleteEnabled ? "none" : "billing address-line2"}
                            hint={<FormattedMessage {...messages.addressLine2Hint} />}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values[messages.addressLine2.sid]}
                            touched={touched[messages.addressLine2.sid]}
                            errors={errors[messages.addressLine2.sid]}
                        />
                        <Input
                            label={<FormattedMessage {...messages.city} />}
                            type="text"
                            autoComplete={isAddressCompleteEnabled ? "none" : "billing address-level2"}
                            name={messages.city.sid}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values[messages.city.sid]}
                            touched={touched[messages.city.sid]}
                            errors={errors[messages.city.sid]}
                        />
                        <Input
                            label={<FormattedMessage {...messages.country} />}
                            type="text"
                            disabled
                            name={messages.country.sid}
                            autoComplete={isAddressCompleteEnabled ? "none" : "billing country"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values[messages.country.sid]}
                            touched={touched[messages.country.sid]}
                            errors={errors[messages.country.sid]}
                        />
                        <FlexRow>
                            <Select
                                label={<FormattedMessage {...messages.province} className="col-50" />}
                                type="select"
                                options={values[messages.provinceSelectList.sid]}
                                autoComplete={isAddressCompleteEnabled ? "none" : "billing address-level1"}
                                name={messages.province.sid}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values[messages.province.sid]}
                                touched={touched[messages.province.sid]}
                                errors={errors[messages.province.sid]}
                            />
                            <Input
                                label={<FormattedMessage {...messages.postalCode} className="col-50" />}
                                type="text"
                                autoComplete={isAddressCompleteEnabled ? "none" : "billing postal-code"}
                                name={messages.postalCode.sid}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values[messages.postalCode.sid]}
                                touched={touched[messages.postalCode.sid]}
                                errors={errors[messages.postalCode.sid]}
                            />
                        </FlexRow>
                    </ExtendedCol>
                </FlexedItem>
                <Footer>
                    <Button
                        text={<FormattedMessage {...messages.cta} />}
                        type="submit"
                        disabled={(isSubmitting && isAddressValidated) || isEmpty(touched) || !isEmpty(errors)}
                        classes="btn btn-filled-bby"
                    />
                </Footer>
            </FlexContainer>
        </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Cart/Address/AddressForm.js